import { LANGUAGE } from './common';

export enum PRODUCT_CATEGORY {
  KARAOKE = 'K-ARAOKE',
  BIXBY = 'BIXBY',
}

export enum USER_PRODUCT_STATUS {
  SINGLE = 'SINGLE',
  SINGLE_CANCELLED = 'SINGLE_CANCELLED',
  SUB_CREATED = 'SUB_CREATED',
  SUB_ACTIVATED = 'SUB_ACTIVATED',
  SUB_DEACTIVATED = 'SUB_DEACTIVATED',
  SUB_TERMINATED = 'SUB_TERMINATED',
  SUB_CANCELLED = 'SUB_CANCELLED',
}

export enum PRODUCT_REGION {
  GLOBAL = 'GLOBAL',
  KR = 'KR',
}

export const PRODUCT_GUIDE = {
  [PRODUCT_CATEGORY.KARAOKE + LANGUAGE.KO]: [
    ['bg-bluey-purple-2', 'img_karaoke_dt_kr_1', 'shape-1'],
    ['bg-light-gray-3', 'img_karaoke_dt_kr_2'],
    ['bg-light-gray-3', 'img_karaoke_dt_kr_3', 'shape-2'],
  ],
  [PRODUCT_CATEGORY.KARAOKE + LANGUAGE.EN]: [
    ['bg-bluey-purple-2', 'img_karaoke_dt_en_1', 'shape-1'],
    ['bg-light-gray-3', 'img_karaoke_dt_en_2'],
    ['bg-light-gray-3', 'img_karaoke_dt_en_3', 'shape-2'],
  ],
  [PRODUCT_CATEGORY.BIXBY + LANGUAGE.KO]: [
    ['bg-topaz', 'img_bixby_dt_kr_1', 'shape-3'],
    ['bg-light-gray-3', 'img_bixby_dt_kr_2'],
    ['bg-light-gray-3', 'img_bixby_dt_kr_3', 'shape-4'],
  ],
  [PRODUCT_CATEGORY.BIXBY + LANGUAGE.EN]: [
    ['bg-topaz', 'img_bixby_dt_en_1', 'shape-3'],
    ['bg-light-gray-3', 'img_bixby_dt_en_2'],
    ['bg-light-gray-3', 'img_bixby_dt_en_3', 'shape-4'],
  ],
};
